import { render, staticRenderFns } from "./BlockchainIntegrationTestDashboard2.vue?vue&type=template&id=4af4be99&scoped=true"
import script from "./BlockchainIntegrationTestDashboard2.vue?vue&type=script&lang=js"
export * from "./BlockchainIntegrationTestDashboard2.vue?vue&type=script&lang=js"
import style0 from "./BlockchainIntegrationTestDashboard2.vue?vue&type=style&index=0&id=4af4be99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4be99",
  null
  
)

export default component.exports